module.exports = __webpack_public_path__ + "img/Envelope.ba20d10b.svg";